import { Component, Input } from '@angular/core';
// Services
import { RulesChangeService } from '../../services/rules-change.service';
// Models
import { RULE_MESSAGE_TYPE } from '../../../../../../../rule-engine/rules/models';
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-schema-render-add-rule',
	templateUrl: './add-rule.component.html'
})
export class AddRuleComponent {
	@Input() path;
	public ruleMessageType = RULE_MESSAGE_TYPE;
	// processing = false;

	newRule: any = {
		messageType: RULE_MESSAGE_TYPE.Info,
		title: '',
		description: '',
		sortId: 0
	}

	get processing(): boolean {
		return this.rulesChangeService.rulesWorkFlow.processing;
	}

	constructor(private rulesChangeService: RulesChangeService) {
		//
	}

	/**
	 * Create a New Rule
	 * @param comment
	 */
	public onCreateNewRule(): void {
		this.rulesChangeService.rulesDataChanged.next({
			type: RulesEvents.NEW_RULE,
			newRule: this.newRule,
			path: this.path
		})
	}

	/**
	 * Change the type of Rule Message
	 * @param event
	 */
	public onSelectRuleMessageType(event: any): void {
		this.newRule.messageType = event.name;
	}

}
